<template>
    <iframe style="height: 100vh; width: 100vw" :src="pdf_uri"></iframe>
</template>


<script>
    import { ref, onMounted, watchEffect } from "vue";
    import { useRoute, useRouter } from "vue-router";

    import { G, ajax } from "@/_common";

    export default {
        name: "PDFViewer",
        props: {
            url: String,
            data: Object,
        },
        setup() {
            const route = useRoute();
            const router = useRouter();

            const pdf_uri = ref(null);
            // const pdf_token = ref(null);

            // const imageEncode = (arrayBuffer) => {
            //     let u8 = new Uint8Array(arrayBuffer);
            //     let b64encoded = btoa(
            //         [].reduce.call(
            //             new Uint8Array(arrayBuffer),
            //             function (p, c) {
            //                 return p + String.fromCharCode(c);
            //             },
            //             ""
            //         )
            //     );
            //     let mimetype = "application/pdf";
            //     return "data:" + mimetype + ";base64," + b64encoded;
            //     // return base64ToUint8Array(b64encoded)

            //     // let image = btoa(
            //     //     new Uint8Array(arrayBuffer).reduce( (data, byte) => data + String.fromCharCode(byte), "")
            //     // );
            //     // return `data:${response.headers["content-type"].toLowerCase()};base64,${image}`;
            // };

            // const base64ToUint8Array = (base64) => {
            //     var raw = atob(base64);
            //     var uint8Array = new Uint8Array(raw.length);
            //     for (var i = 0; i < raw.length; i++) {
            //         uint8Array[i] = raw.charCodeAt(i);
            //     }
            //     return uint8Array;
            // };

            watchEffect(() => {});

            onMounted(async () => {
                // let ldata = new FormData();
                // ldata.append("email", "test@meclis.gov.az");
                // await ajax({
                //     url: "/login/smartlaw",
                //     method: "post",
                //     data: ldata,
                //     success: async (e) => {
                //         pdf_token.value = e.data.token;
                //         await ajax({
                //             url:
                //                 G.ajaxBaseUrl + `/${route.params.view}/az/pdf/` +
                //                 decodeURIComponent(route.params.url),
                //             responseType: "arraybuffer",
                //             header: {
                //                 "X-MM-Gundelik": "MM_smart_gundelik",
                //                 Authorization: pdf_token.value,
                //             },
                //             success: (e) => {
                //                 let res = e.data || null;
                //                 // pdf_uri.value = imageEncode(e.data);
                //                 // var enc = new TextDecoder("utf-8");
                //                 // var arr = new Uint8Array(e.data);
                //                 // pdf_uri.value = enc.decode(arr);
                //                 pdf_uri.value = URL.createObjectURL(new Blob([e.data], {
                //                   type: "application/pdf"
                //                 }));
                //                 // pdf_uri.value = e.data;
                //                 // console.log(Buffer.from(e.data, 'binary').toString('base64'));
                //                 // pdf_uri.value = Buffer.from(e.data, 'binary').toString('base64');
                //             },
                //             error: (e) => {
                //                 console.log(e);
                //                 // pdf_uri.value = atob(e.data);
                //             },
                //         });
                //     },
                // });

                await ajax({
                    url:
                        G.ajaxBaseUrl +
                        `/${route.params.view}/az/pdf/` + (route.params.id !== undefined ? (route.params.id + '/') : '') +
                        decodeURIComponent(route.params.url) + '?t=' + new Date().valueOf(),
                    responseType: "arraybuffer",
                    success: (e) => {
                        // let res = e.data || null;
                        // pdf_uri.value = imageEncode(e.data);
                        // var enc = new TextDecoder("utf-8");
                        // var arr = new Uint8Array(e.data);
                        // pdf_uri.value = enc.decode(arr);
                        pdf_uri.value = URL.createObjectURL(
                            new Blob([e.data], {
                                type: "application/pdf",
                            })
                        );
                        // pdf_uri.value = e.data;
                        // console.log(Buffer.from(e.data, 'binary').toString('base64'));
                        // pdf_uri.value = Buffer.from(e.data, 'binary').toString('base64');
                    },
                    error: () => {
                        // console.log(e);
                        // console.log(router.resolve({ name: 'notfound' }));
                        pdf_uri.value = 'http://localhost:8080' + router.resolve({ name: 'notfound_full' }).path;
                        // pdf_uri.value = 'http://localhost:8080' + router.resolve({ name: 'notfound_full' }).path;
                    },
                });
            });

            return { pdf_uri };
        },
    };
</script>
